import { render, staticRenderFns } from "./UserTrainingCourseUpdate.vue?vue&type=template&id=5110602e&"
import script from "./UserTrainingCourseUpdate.vue?vue&type=script&lang=js&"
export * from "./UserTrainingCourseUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports